<template>
  <el-dialog title="修改订单规则" :visible.sync="dialogVisible" width="420px" :before-close="handleClose">
    <div class="content">
      <div>1、修改支付时间为当月的订单，按照员工当月的提成比例进行计算；</div>
      <div>2、修改支付时间为之前月份的订单，根据订单支付时间按照员工相应月份的提成比例进行计算；</div>
      <div>3、修改订单的分成比例后，调整当月员工的分成比例，会覆盖当月手动调整的订单分成比例。</div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="handleClose">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ruleDialog',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 8px;
  color: #333;
  line-height: 30px;
}
</style>
